import { combineReducers as reduxCombineReducers } from 'redux';
import auth from './auth';
import options from './options';
import media from './media';
import consoleResponse from './consoleResponse';

const reducers: Record<string, unknown> = { auth, options, media, consoleResponse };

export const combineReducers = (externalReducers = {}) => reduxCombineReducers({ ...reducers, ...externalReducers });
